import type {DetailsType} from '@cypro/engine/database/schema'

/**
 * Translation keys describing how a prescription was administered (mode, and a skipped patient scan),
 * read from its ADMINISTER status-change log. Empty for other events and for older logs.
 */
export function getAdministrationLogKeys(details: DetailsType | null | undefined): string[] {
  if (details?.action !== 'ADMINISTER' || !details.administrationMode) return []
  const keys = [`settings.administrationMode.${details.administrationMode.toLowerCase()}`]
  if (details.patientScanSkipped === 'true') keys.push('patient_scan_skipped')
  return keys
}
